export default angular.module('eventix.common.services.helpers', [])
    .factory('generateRandomString', function() {
        return  function generateRandomString(length, charset) {
            var chars;
            switch(charset) {
                case 'secure':
                    chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXZY1234567890!@#$%^&*()[]=?+{}-_;:\|/"\'';
                    break;
                case 'alpha':
                case 'letters':
                    chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXZY';
                    break;
                case 'num':
                case 'digits':
                case 'numbers':
                case 'numeric':
                    chars = '1234567890';
                    break;
                case 'alphanum':
                case 'alphanumeric':
                    chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXZY1234567890';
                    break;
                default:
                    chars = 'abcdefghkmnpqrstuvwxyzABCDEFGHKMNPQRSTUVWXZY23456789';
                    break;
            }
            let random = '';
            for(let i = 0; i < length; i++)
                random += chars.charAt(Math.round(Math.random() * (chars.length - 1)));
            return random;
        };
    })
    .name;
